import $ from 'jquery';
import Swiper from 'swiper/dist/js/swiper';
import onDocumentReady from '../utilities/onDocumentReady';

const sliders = {};

const createSlider = (sliderContainer) => {
    return new Swiper(sliderContainer.find('.catalog-linked-slider-container'), {
        speed: 600,
        spaceBetween: 20,
        slidesPerView: 4,
        slidesPerGroup: 4,
        autoHeight: true,
        pagination: {
            el: sliderContainer.find('.catalog-linked-control__pagination'),
            type: 'fraction',
        },
        navigation: {
            nextEl: sliderContainer.find('.catalog-linked-control__button--next'),
            prevEl: sliderContainer.find('.catalog-linked-control__button--prev'),
        },

        breakpoints: {
            767: {
                slidesPerView: 1,
                slidesPerGroup: 1,
            },
            1023: {
                slidesPerView: 2,
                slidesPerGroup: 2,
            },
            1439: {
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
        },

    });
};

$(document).on('prices-updated', function () {
    $('.catalog-linked .ui-product').not('.ui-product--available').parents('.swiper-slide').remove();
    $('.catalog-linked').each(function (index) {
        $(this).fadeIn();
        sliders[index] = createSlider($(this));
        $(this).find('.ui-product').trigger('render');
        return true;
    });
});
